<script setup>
import { reactiveOmit } from "@vueuse/core"
import { useForwardPropsEmits } from "reka-ui"
import { OTPInput } from "vue-input-otp"
import { cn } from "@/lib/utils"

const props = defineProps({
  modelValue: { type: String, required: false },
  defaultValue: { type: String, required: false },
  maxLength: { type: Number, required: false },
  pattern: { type: [String, Object], required: false },
  disabled: { type: Boolean, required: false },
  readonly: { type: Boolean, required: false },
  required: { type: Boolean, required: false },
  inputmode: { type: String, required: false },
  textAlign: { type: String, required: false },
  autocomplete: { type: String, required: false },
  autofocus: { type: Boolean, required: false },
  placeholder: { type: String, required: false },
  containerClass: { type: String, required: false },
  class: { type: null, required: false },
})

const emits = defineEmits(["update:modelValue", "complete", "change", "select", "input", "focus", "blur", "mouseover", "mouseleave", "paste"])

const delegatedProps = reactiveOmit(props, "class")

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <OTPInput
    v-slot="slotProps"
    v-bind="forwarded"
    :container-class="cn('flex items-center gap-2 has-disabled:opacity-50', props.class)"
    data-slot="input-otp"
    class="disabled:cursor-not-allowed"
  >
    <slot v-bind="slotProps" />
  </OTPInput>
</template>